import { render, staticRenderFns } from "./ChemicalForm.vue?vue&type=template&id=94267f20"
import script from "./ChemicalForm.vue?vue&type=script&lang=js"
export * from "./ChemicalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports